import React from 'react'
import eduIcon from '../../../assets/images/front/logos/edu.png'
import hnIcon from '../../../assets/images/front/logos/hn.png'
import novaIcon from '../../../assets/images/front/logos/nova.png'
import ctIcon from '../../../assets/images/front/logos/ct.png'

const Partners: React.FC = () => {
  return (
    <div className="px-4 lg:px-0">
      {' '}
      <div className="container px-4 mt-[30px] md:mt-[60px] flex flex-col md:flex-row items-center justify-center">
        <h4 className="text-[#0183BA] text-xl md:text-[25px] mb-4 md:mb-0 md:me-4 text-center md:text-start">
          mohli jste nás vidět:
        </h4>
        <div className="flex flex-wrap items-center gap-2">
          <img
            src={eduIcon}
            alt=""
            className="inline-block max-w-1/2 md:mr-2 mb-3 md:mb-0"
            width="130"
          />
          <img
            src={hnIcon}
            alt=""
            className="inline-block max-w-1/2 md:mr-2 mb-3 md:mb-0"
            width="220"
          />
          <img
            src={novaIcon}
            alt=""
            className="inline-block max-w-1/2 md:mr-2 mb-3 md:mb-0"
            width="100"
          />
          <img src={ctIcon} alt="" className="inline-block max-w-1/2 mb-3 md:mb-0" width="212" />
        </div>
      </div>
    </div>
  )
}

export default Partners
